import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface RichTextProps {
    html: string
    className?: string
}

/**
 * The single renderer for every CMS rich text value. Styles live in
 * src/styles/rich-text.css under the rich-text class. Content comes from
 * the site owner through the CMS, never from visitors.
 */
export const RichText: FC<RichTextProps> = ({ html, className }): ReactNode => {
    return (
        <div
            className={cn('rich-text', className)}
            dangerouslySetInnerHTML={{ __html: html }}
        />
    )
}
